import(/* webpackMode: "eager" */ "/vercel/path0/src/app/loading.tsx")